import React, { useEffect, useContext, useState } from "react";
import { useHistory } from "react-router";
import { PortalContext } from "../../context/Provider";
import {
  logoutEstudiosTurnos,
  wsPostTomarTurnoKinesioQr,
  wsPostTurnosKinesioQr,
} from "../../context/Actions/turnos/estudioTurnos";
import { hideModal, showModal } from "../../context/Actions/modal/modal";
import { logoutConsultaMedTurnos } from "../../context/Actions/turnos/consultaMedTurnos";
import { logoutLaboTurnos } from "../../context/Actions/turnos/laboTurnos";
import {
  editaTurnosDisponibles,
  finalizaTurnosDisponibles,
  resetFiltrosDisponibles,
} from "../../context/Actions/turnos/turnosDisponibles";
import { showToaster } from "../../../global/context/action/toaster/toaster";
import Modal from "../../components/Genericos/Modal/Modal";
import HeaderBarKin from "../../components/Turnos/HeaderBarKin/HeaderBarKin";
import camelize from "../../../global/utils/camelize";
import ConsultaIcon from "../../assets/images/generico/ConsultaIcon";
import ViewIcon from "../../assets/images/generico/ViewIcon";
import EtiquetaGrupoModal from "../../components/Turnos/EtiquetaGrupoModal/EtiquetaGrupoModal";
import CardTurnoKin from "../../components/Turnos/CardTurnoKin/CardTurnoKin";
import fechaTurnoFormat from "../../../global/utils/fechaTurnoFormat";
import "./TurnosDisponiblesKin.css";
import { SetUserProximoTurno } from "../../context/Actions/DropDownFamiliares/selectFamiliares";
import TurnoNoEncontrado from "../../components/Genericos/TurnoNoEcontrado/TurnoNoEncontrado";
import {
  guardarTipoTurno,
  guardarUltimoTurno,
  limpiarDatosMedico,
  limpiarTipoTurno,
  limpiarUltimoTurno,
  resetIdTurnoSolicitud,
} from "../../context/Actions/turnos/turnosPaciente";
import {
  hideSegundoModal,
  showSegundoModal,
} from "../../context/Actions/segundoModal/segundoModal";
import SegundoModal from "../../components/Genericos/SegundoModal/SegundoModal";
import { GlobalContext } from "../../../global/context/Provider";
import Loading from "_+_Portal/components/Genericos/Loading/Loading";
import { motion } from "framer-motion";
import ToasterV2 from "global/component/Genericos/Toaster/ToasterV2";

const TurnosDisponiblesKin = () => {
  const {
    modalState,
    segundoModalState,
    modalDispatch,
    segundoModalDispatch,
    estudioTurnosDispatch,
    estudioTurnosState,
    consultaMedTurnosState,
    consultaMedTurnosDispatch,
    turnosDisponiblesState,
    turnosDisponiblesDispatch,
    laboTurnosState,
    laboTurnosDispatch,
    selectDropDownState,
    selectDropDownDispatch,
    turnosPacienteDispatch,
    textosState,
  } = useContext(PortalContext);

  const { authState, toasterDispatch, toasterState, configState } =
    useContext(GlobalContext);

  const [descEspecialidad, setDescEspecialidad] = useState(false);
  const [grupoMedicoOk, setGrupoMedicoOk] = useState(false);
  const [agrupaEtiqueta, setAgrupaEtiqueta] = useState(false);
  const [dtoNuevaBusqueda, setDtoNuevaBusqueda] = useState();
  const [flgActualizarTurnos, setFlgActualizarTurnos] = useState(false);
  const [onChangeDate, setOnChangeDate] = useState(null);
  const [confimoTurno, setConfirmoTurno] = useState(false);
  const [flgTurnosKin, setFlgTurnosKin] = useState(false);

  let accion = sessionStorage.getItem("accionHash");
  const history = useHistory();
  const fecha = new Date();
  const widthWindow = window.innerWidth;

  const handleClickVolver = () => {
    logoutEstudiosTurnos()(estudioTurnosDispatch);
    logoutConsultaMedTurnos()(consultaMedTurnosDispatch);
    logoutLaboTurnos()(laboTurnosDispatch);
    resetFiltrosDisponibles()(turnosDisponiblesDispatch);
    limpiarUltimoTurno()(turnosPacienteDispatch);
    limpiarTipoTurno()(turnosPacienteDispatch);
    finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
    if (configState.config.data.opcBuscadorTurnos && widthWindow > 1024) {
      history.push("/buscadorTurnos");
    } else {
      history.push("/estudios");
    }
  };

  const dissmiss = () => {
    hideSegundoModal()(segundoModalDispatch);
  };
  const dissmissConfirmacion = () => {
    hideModal()(modalDispatch);
  };

  const showModalTurnosHorarios = (e) => {
    modalTurnosYHorarios(e);
  };

  const modalTurnosYHorarios = (e) => {
    showSegundoModal(
      "Turnos/CardTurnoKin/ModalTurnosKin",
      {
        turno: e,
        dissmiss: dissmiss,
        confirmarTurnoModal: handleOnClickConfirmar,
      },
      {},
      "centro"
    )(segundoModalDispatch);
  };

  const onClickShowDeterminaciones = () => {
    showModal(
      "Genericos/Mensaje/Mensaje",
      {
        titulo: "Tus turnos agregados",
        texto: <EtiquetaGrupoModal />,
        dissmiss: dissmiss,
      },
      [
        {
          text: "Continuar",
          clase: "btn-Mensaje-1 bgc-black10 cursor:pointer rb18m c-white",
          accion: dissmiss,
        },
      ],
      "centro"
    )(modalDispatch);
  };

  const handleOnClickConfirmar = (e) => {
    hideSegundoModal()(segundoModalDispatch);
    let paciente =
      selectDropDownState.selectDropDown.selectGlobal.pacienteElegido;
    let familiar = paciente.familiar;
    showModal(
      "Turnos/ConfirmarTurnoKin/ConfirmarTurnoKin",
      {
        confirmarTurnoKin: confirmarTurnoModal,
        paciente: !familiar ? paciente : paciente,
        authState,
        nroSesion: e.nroSesion,
        centro: e.centro,
        ubicacion: e.ubicacion,
        dissmiss: dissmissConfirmacion,
      },
      {},
      "centro"
    )(modalDispatch);
  };

  const confirmarTurnoModal = (e) => {
    let item =
      turnosDisponiblesState.turnosDisponibles.turnosData.turnos.filter(
        (item) => e === item.nroSesion
      );
    if (estudioTurnosState.estudioTurnos.data !== null) {
      let config = localStorage.getItem("config");
      let sectorTurno = JSON.parse(config).sectorTurno;

      let dtoTomaTurno = {
        idGrupoMedico:
          turnosDisponiblesState.turnosDisponibles.turnosData.idEstudio,
        particular:
          turnosDisponiblesState.turnosDisponibles.turnosData.particular,
        turnos: item,
        sectorTurno,
        osAlternativa:
          turnosDisponiblesState.turnosDisponibles.turnosData?.dtoBusqueda
            ?.osAlternativa,
      };
      let paciente =
        selectDropDownState.selectDropDown.selectGlobal.pacienteElegido;

      SetUserProximoTurno(paciente.familiar)(selectDropDownDispatch);
      wsPostTomarTurnoKinesioQr(dtoTomaTurno)(estudioTurnosDispatch);
      guardarUltimoTurno(dtoTomaTurno.turnos[0].idturno)(
        turnosPacienteDispatch
      );
      guardarTipoTurno({
        tipo: "ESTUDIO",
        estudio:
          turnosDisponiblesState.turnosDisponibles.turnosData.descEstudio,
        circuito: turnosDisponiblesState.turnosDisponibles.turnosData.circuito,
      })(turnosPacienteDispatch);
      setConfirmoTurno(true);
      hideModal()(modalDispatch);
    }
  };

  useEffect(() => {
    resetIdTurnoSolicitud()(turnosPacienteDispatch);
    limpiarDatosMedico()(turnosPacienteDispatch);
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (confimoTurno) {
      if (
        estudioTurnosState.estudioTurnos.data === "" ||
        consultaMedTurnosState.consultaMedTurnos.data > 100 ||
        (laboTurnosState.laboTurnos.data !== null &&
          laboTurnosState.laboTurnos.data !== undefined &&
          laboTurnosState.laboTurnos.data.hora > 1)
      ) {
        logoutEstudiosTurnos()(estudioTurnosDispatch);
        resetFiltrosDisponibles()(turnosDisponiblesDispatch);
        finalizaTurnosDisponibles()(turnosDisponiblesDispatch);
        if (accion) {
          sessionStorage.removeItem("accionHash");
        }
        history.push("/proximosTurnos");
        setConfirmoTurno(false);
      } else if (
        (estudioTurnosState.estudioTurnos.error !== false &&
          estudioTurnosState.estudioTurnos.data !== null) ||
        (consultaMedTurnosState.consultaMedTurnos.error !== false &&
          consultaMedTurnosState.consultaMedTurnos.error !== null) ||
        (laboTurnosState.laboTurnos.error !== false &&
          laboTurnosState.laboTurnos.error !== null)
      ) {
        showToaster(
          {
            texto: "Error al tomar el turno",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
        if (
          turnosDisponiblesState.turnosDisponibles.turnosData.descEstudio ===
          "KINESIOLOGIA"
        ) {
          if (accion) {
            sessionStorage.removeItem("accionHash");
          }
          history.push("/proximosTurnos");
        }
      }
    }
  }, [estudioTurnosState]);

  const showModalKinesio = () => {
    //saco el domingo ya que no entra dentro de los dias.
    showModal(
      "Turnos/FiltrosKinesio/FiltrosKinesio",
      {
        titulo: "Filtrar por dia y hora",
        dissmiss: dissmiss,
        onChangeDatePicker: onChangeDatePicker,
        onHandleBuscarTurnosKin: onHandleBuscarTurnosKin,
        fecha: fecha,
      },
      [],
      "centro",
      true
    )(modalDispatch);
  };

  const onChangeDatePicker = (e) => {
    if (e !== null) {
      setOnChangeDate(e);
    }
  };

  const onHandleBuscarTurnosKin = () => {
    setFlgTurnosKin(true);
  };

  useEffect(() => {
    if (flgTurnosKin) {
      let auxDias =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.diasKin.filter(
          (item) => item.checked !== false && item.id !== 0
        );
      let auxKin =
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.rangoKinesio.filter(
          (item) => item.checked !== false && item.id !== 0
        );
      // // Filtrado provisorio de días
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .diasKin[0]?.checked
      ) {
        auxDias =
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.diasKin.filter(
            (item) => item.id !== 0
          );
      }

      // // Filtrado provisorio de rangoKinesio
      if (
        turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
          .rangoKinesio[0]?.checked
      ) {
        auxKin =
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData.rangoKinesio.filter(
            (item) => item.id !== 0
          );
      }

      if (auxDias.length >= 3 && auxKin.length > 0) {
        auxDias = auxDias.map((array) => array.id);
        auxKin = auxKin.map((array) => array.rango);
        let config = localStorage.getItem("config");
        let sectorTurno = JSON.parse(config).sectorTurno;
        let dtoKin = {
          cantidad: 10,
          fechaDesde: onChangeDate !== null ? onChangeDate : fechaTurnoFormat(),
          idGrupoMedico:
            turnosDisponiblesState.turnosDisponibles.turnosData.idEstudio,
          listDias: auxDias,
          listHorario: auxKin,
          particular:
            turnosDisponiblesState.turnosDisponibles.turnosData.particular,
          sectorTurno,
        };
        setFlgTurnosKin(false);
        setFlgActualizarTurnos(true);
        hideModal()(modalDispatch);
        wsPostTurnosKinesioQr(dtoKin)(estudioTurnosDispatch);
      } else {
        setFlgTurnosKin(false);
        showToaster(
          {
            texto: "Seleccione al menos 1 rango horario y 3 dias de la lista",
            tipo: "danger",
          },
          "centroArriba"
        )(toasterDispatch);
      }
    }
  }, [flgTurnosKin]);

  const handleActualizaTurnos = () => {
    setFlgActualizarTurnos(true);
  };

  //HAY QUE MEJORAR Y PREPARAR LA LOGICA PARA TODAS LAS BUSQUEDAS DESDE ACA.

  const onClickProximosTurnos = () => {
    dissmiss();
    let fechaSliced =
      turnosDisponiblesState.turnosDisponibles.turnosData.fechaBusqueda;
    if (onChangeDate !== null) {
      fechaSliced = onChangeDate;
    }
    // setFlgNuevaBusqueda(true);
    if (estudioTurnosState.estudioTurnos.data !== null) {
      setOnChangeDate(sumoDias(fechaSliced, 7));
      setFlgTurnosKin(true);
    }
  };

  const sumoDias = (fecha, dias) => {
    let diaAux = new Date(fecha);
    //agrego uno mas porque la fecha local toma 1 dia menos.
    diaAux.setDate(diaAux.getDate() + dias + 1);
    //formateo la fecha
    return (
      diaAux.getFullYear() +
      "-" +
      (diaAux.getMonth() + 1 < 10
        ? "0" + (diaAux.getMonth() + 1)
        : diaAux.getMonth() + 1) +
      "-" +
      (diaAux.getDate() < 10 ? "0" + diaAux.getDate() : diaAux.getDate())
    );
  };

  useEffect(() => {
    if (flgActualizarTurnos) {
      editaTurnosDisponibles({
        ...turnosDisponiblesState.turnosDisponibles.turnosData,
        turnos: estudioTurnosState.estudioTurnos.data,
        fechaBusqueda:
          onChangeDate !== null ? onChangeDate : fechaTurnoFormat(),
        dtoBusqueda: dtoNuevaBusqueda,
      })(turnosDisponiblesDispatch);
    }
  }, [estudioTurnosState]);

  useEffect(() => {
    if (configState.config.data !== null) {
      if (turnosDisponiblesState.turnosDisponibles.turnosData.turnos === null) {
        // aca podria agregar la data de que busco porque actualmente se limpia
        if (configState.config.data.opcBuscadorTurnos && widthWindow > 1024) {
          history.push("/buscadorTurnos");
        } else {
          history.push("/estudios");
        }
      } else {
        if (
          turnosDisponiblesState.turnosDisponibles.turnosData
            .descEspecialidad !== "" &&
          turnosDisponiblesState.turnosDisponibles.turnosData
            .descEspecialidad !== null
        ) {
          setDescEspecialidad(true);
        }
        if (
          turnosDisponiblesState.turnosDisponibles.turnosData.grupoMedico !==
          null
        ) {
          setGrupoMedicoOk(true);
          if (
            turnosDisponiblesState.turnosDisponibles.turnosData.grupoMedico
              .length > 1
          ) {
            setAgrupaEtiqueta(true);
          }
        }
        setDtoNuevaBusqueda(
          turnosDisponiblesState.turnosDisponibles.turnosData.dtoBusqueda
        );
      }
    }
  }, [configState.config.data]);

  return (
    <React.Fragment>
      {modalState.modal.show && <Modal />}
      {segundoModalState.segundoModal.show && <SegundoModal />}
      {toasterState.toaster.show && <ToasterV2 />}
      <Loading
        dataLoading={estudioTurnosState.estudioTurnos.loading}
        color="c-white"
        descripcion={
          estudioTurnosState.estudioTurnos.loading && "Tomando turno..."
        }
      />
      <HeaderBarKin
        handleClickVolver={handleClickVolver}
        turnosData={turnosDisponiblesState.turnosDisponibles.turnosData.turnos}
        filtrosData={
          turnosDisponiblesState.turnosDisponibles.turnosData.filtrosData
        }
        handleActualizaTurnos={handleActualizaTurnos}
      />
      <div className="ptur-turnosDisponiblesKin-headerTurno">
        <div className="ptur-turnosDisponiblesKin-etiqueta">
          <ConsultaIcon color={"var(--color-white)"} />
          {turnosDisponiblesState.turnosDisponibles.turnosData.particular ? (
            <span className="ptur-turnosAgregados-descParticular c-white rb14b">
              PARTICULAR:
            </span>
          ) : (
            ""
          )}
          <span className="ptur-turnosDisponiblesKin-etiquetaDesc c-white rb14l">
            {grupoMedicoOk ? (
              agrupaEtiqueta ? (
                <button
                  onClick={() => onClickShowDeterminaciones()}
                  className="ptur-turnosAgregados-cancelarBtn c-white"
                >
                  VER ESTUDIOS AGREGADOS
                  <span className="ptur-turnosDisponiblesKin-viewIcon">
                    <ViewIcon />
                  </span>
                </button>
              ) : descEspecialidad ? (
                turnosDisponiblesState.turnosDisponibles.turnosData
                  .descEspecialidad
              ) : (
                turnosDisponiblesState.turnosDisponibles.turnosData.descEstudio
              )
            ) : descEspecialidad ? (
              turnosDisponiblesState.turnosDisponibles.turnosData
                .descEspecialidad
            ) : (
              turnosDisponiblesState.turnosDisponibles.turnosData.descEstudio
            )}
          </span>
        </div>
        <div className="ptur-turnosDisponiblesKin-filtrosMobile-container">
          <button
            onClick={showModalKinesio}
            className="ptur-turnosDisponiblesKin-filtrosMobile-btn c-latex30 rb18mh"
          >
            Filtros
          </button>
          <button
            onClick={onClickProximosTurnos}
            className="ptur-turnosDisponiblesKin-proxTurnosBtn anchoDisable600Min"
          >
            Buscar más turnos
          </button>
        </div>
        <div className="ptur-turnosDisponiblesKin-proxTurnosBar">
          <button
            onClick={onClickProximosTurnos}
            className="ptur-turnosDisponiblesKin-proxTurnosBtn anchoDisable600Max"
          >
            Buscar más turnos
          </button>
          <p className="rb16m ptur-turnosDisponibles-proxTurnosBar-title">
            {" "}
            <span style={{ marginRight: "10px" }}>Para:</span>
            {turnosDisponiblesState.turnosDisponibles.turnosData
              .volverOrigen === "CONSULTA_MEDICA"
              ? !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                ? authState.auth.data.paciente.nombre
                : selectDropDownState.selectDropDown.selectGlobal
                    .pacienteElegido.paciente.nombre
              : turnosDisponiblesState.turnosDisponibles.turnosData
                  .volverOrigen === "ESTUDIOS"
              ? !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                ? authState.auth.data.paciente.nombre
                : selectDropDownState.selectDropDown.selectGlobal
                    .pacienteElegido.paciente.nombre
              : turnosDisponiblesState.turnosDisponibles.turnosData
                  .volverOrigen === "LABORATORIO"
              ? !selectDropDownState.selectDropDown.selectGlobal.pacienteElegido
                ? authState.auth.data.paciente.nombre
                : selectDropDownState.selectDropDown.selectGlobal
                    .pacienteElegido.paciente.nombre
              : authState.auth.data.paciente.nombre}
          </p>
        </div>
      </div>
      <div className="ptur-turnosDisponiblesKin-bodyContainer">
        {estudioTurnosState.estudioTurnos.loading ||
        consultaMedTurnosState.consultaMedTurnos.loading ||
        laboTurnosState.laboTurnos.loading ? (
          ""
        ) : (
          <>
            <TurnoNoEncontrado
              state={
                turnosDisponiblesState.turnosDisponibles?.turnosData?.turnos
              }
              loadingState={turnosDisponiblesState.turnosDisponibles}
              fecha={new Date(
                turnosDisponiblesState.turnosDisponibles.turnosData.fechaBusqueda
              ).toLocaleDateString()}
              texto={textosState.textos.data?.msjSinTurnoDisponible?.nombre.slice(
                0,
                -7
              )}
              recomendacion={
                textosState.textos.data?.msjSinTurnoDisponible?.descripcion
              }
              txtBtn="Proximos turnos disponibles"
              onClickTurnos={onClickProximosTurnos}
              showBtn={true}
            />
          </>
        )}

        <motion.div
          initial={{ opacity: 0, y: +100 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: 100 }}
          transition={{ duration: 0.4 }}
          className="ptur-turnosDisponiblesKin-boxTurnos-body"
        >
          {estudioTurnosState.estudioTurnos.loading
            ? ""
            : turnosDisponiblesState.turnosDisponibles.turnosData.turnos?.map(
                (item, index) => {
                  return (
                    <React.Fragment key={index}>
                      <CardTurnoKin
                        handleOnClickConfirmar={() =>
                          handleOnClickConfirmar(item)
                        }
                        idTurno={item.idturno}
                        medico={camelize(
                          item.medico !== null ? item.medico : item.recepcion
                        )}
                        centro={item.centro}
                        ubicacion={item.ubicacion}
                        hora={item.hora}
                        fecha={item.fecha}
                        especialidad={
                          item.especialidad !== null
                            ? camelize(item.especialidad)
                            : ""
                        }
                        infoSesion={item.infoSesion}
                        nroOrden={item.nroOrden}
                        nroSesion={item.nroSesion}
                        handleOnClickVerTurnos={() =>
                          showModalTurnosHorarios(item)
                        }
                      />
                    </React.Fragment>
                  );
                }
              )}
        </motion.div>
        <div className="footerHelp"></div>
      </div>
    </React.Fragment>
  );
};

export default TurnosDisponiblesKin;
